/**
 * 1. Should show survey (has seen)
 * 2. Set Survey seen (Capture event)
 * seenSurveyWaitPeriodInDays (number)
 */
import { useCallback } from "react";
import { useSurveyLastSeenStore } from "./useSurveyLastSeenStore";
import { useSurveyStore } from "./useSurveyStore";
const daysToMs = (days) => days * 24 * 60 * 60 * 1000;
const isInWaitPeriod = (lastSeen, waitPeriodInDays) => {
    if (!lastSeen || !waitPeriodInDays)
        return false;
    return daysToMs(waitPeriodInDays) > Date.now() - lastSeen;
};
export const usePostHogSurvey = (surveyId, options) => {
    const { userId, needUserId = false } = options ?? {};
    const { payloads } = useSurveyStore();
    const { getSurveyLastSeen, setSurveyLastSeen } = useSurveyLastSeenStore();
    const payload = payloads?.[surveyId];
    const lastSeen = getSurveyLastSeen(surveyId, userId);
    const isValidUserId = (needUserId && !!userId) || !needUserId;
    const waitPeriod = payload?.conditions?.seenSurveyWaitPeriodInDays;
    const isSurveyActive = isValidUserId && !!payload && !isInWaitPeriod(lastSeen, waitPeriod);
    const updateSurveyLastSeen = useCallback(() => setSurveyLastSeen(surveyId, userId), [surveyId, userId]);
    return { payload, isSurveyActive, updateSurveyLastSeen };
};
